/* projects/shared/src/lib/components/generic-datetimepicker/generic-datetimepicker.component.scss */
:host ::ng-deep .calendar-full {
  width: 100%;
}
:host ::ng-deep .calendar-full {
  width: 100%;
  display: flex;
  align-items: center;
}
:host ::ng-deep .calendar-full .p-inputtext {
  height: 56px;
  padding: 26px 12px 4px;
  box-sizing: border-box;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.56);
  border-radius: 0;
  outline: none;
}
:host ::ng-deep .calendar-full .p-calendar {
  width: 100%;
}
:host ::ng-deep .calendar-full .p-datepicker-trigger {
  height: 56px;
}
:host ::ng-deep p-datepicker.invalid .p-inputtext {
  border-bottom: 1px solid red;
}
:host ::ng-deep .p-calendar .p-inputtext:enabled:focus,
:host ::ng-deep .calendar-full .p-inputtext:enabled:focus,
:host ::ng-deep .p-datepicker .p-inputtext:enabled:focus,
:host ::ng-deep .p-inputtext:enabled:focus {
  box-shadow: none !important;
  outline: none !important;
  border-bottom: 2px solid #4186c6 !important;
  transition: border-bottom-color 0.18s ease;
}
:host ::ng-deep .p-datepicker .p-datepicker-input-icon-container {
  position: absolute;
  right: 8px;
  top: 48%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  color: rgba(0, 0, 0, 0.56) !important;
}
label {
  padding-left: 12px;
  color: rgba(0, 0, 0, 0.56) !important;
}
.p-floatlabel-on:has(input:focus) label,
.p-floatlabel-on:has(input.p-filled) label,
.p-floatlabel-on:has(input:-webkit-autofill) label,
.p-floatlabel-on:has(textarea:focus) label,
.p-floatlabel-on:has(textarea.p-filled) label,
.p-floatlabel-on:has(.p-inputwrapper-focus) label,
.p-floatlabel-on:has(.p-inputwrapper-filled) label,
.p-floatlabel-on:has(input[placeholder]) label,
.p-floatlabel-on:has(textarea[placeholder]) label {
  top: 30%;
  left: 12px;
  font-size: 12px;
  transform: translateY(-50%);
  border-radius: var(--p-floatlabel-on-border-radius);
  background: var(--p-floatlabel-on-active-background);
  padding: var(--p-floatlabel-on-active-padding);
}
/*# sourceMappingURL=generic-datetimepicker.component.css.map */
